<div class="h-full w-full p-4 content-center text-center font-bold" *ngIf="isWeeklyAgentsNotRun">
    <div class="card-info pb-4">This agent hasn’t run yet, so we don’t have any data to show you.</div>
</div>

<div class="h-full w-full flex flex-col overflow-hidden" *ngIf="!isWeeklyAgentsNotRun">
    <p class="card-sub-header-text" *ngIf="selectedOption && !selectedOption.email_only">Companies and contacts exported
        in the past 4 weeks</p>
    <p class="card-sub-header-text" *ngIf="selectedOption && selectedOption.email_only">New companies and contacts over the past 4 weeks</p>
    <p class="card-sub-header-text" *ngIf="selectedOption === null">All ICP Agent activity over the past 4 weeks</p>
    <ng-container
        *ngIf="(selectedOption === null && isAllAgentsEmailOnly) || (selectedOption && selectedOption.email_only)">
        <ng-container *ngIf="isShowChart then lineChart else tableGrid"></ng-container>
    </ng-container>
    <ng-container
        *ngIf="(selectedOption === null && isAllAgentsExportOnly) || (selectedOption && !selectedOption.email_only)">
        <ng-container *ngIf="isShowChart then lineChart else tableGrid"></ng-container>
    </ng-container>
    <ng-container *ngIf="!isAllAgentsExportOnly && !isAllAgentsEmailOnly && selectedOption === null">
        <ng-container *ngIf="isShowChart then lineChart else combineTable"></ng-container>
    </ng-container>
</div>

<ng-template #lineChart>
    <div class="chart-container h-full w-full flex flex-col overflow-hidden">
        <app-line-chart class="flex flex-col w-full h-full" [chartData]="chartData" legendKeyToHide="All Companies"
            [chartLabels]="chartLabels"></app-line-chart>
    </div>
</ng-template>

<ng-template #combineTable>
    <div class="table-container">
        <app-data-table [data]="tableData" [columns]="combinedtableColumns" sortActive="week_end" sortDirection="asc"
            smallRowHeight="true" [layoutFixed]="false">
        </app-data-table>
    </div>
</ng-template>

<ng-template #tableGrid>
    <div class="table-container">
        <app-data-table [data]="tableData" [columns]="tableColumns" sortActive="week_end" sortDirection="asc"
            smallRowHeight="true" [layoutFixed]="false">
        </app-data-table>
    </div>
</ng-template>
